import React, {useEffect, useState} from 'react';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzText,
    BringzzImage,
    BringzzPostingCard,
    BringzzButton, BringzzBottomDrawer,
    BringzzRotatingSelect,
    BringzzDate,
    Mode, BringzzArticle
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useLocation } from 'react-router-dom';
import useRequest from 'hooks/useRequest';
import AvatarExample from 'assets/images/AvatarExample.png';
import usePageState from 'hooks/usePageState';

import { useAuth } from 'context/AuthContext';
import { hoursOptions, minutesOptions } from 'utils/constants';
import {compressImageToBase64, formatDateToDDMMYYYY, isValidURL, parseToMySQLDateTime} from 'utils';
import {parse, format} from "date-fns";
import {getDataForSubmit} from "../PostHelper";
import PostingCardElement from "../../../components/BringzzPostingCardElement";
import { useTranslation } from 'react-i18next';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const PreviewPost = () => {
    const { t } = useTranslation('posts');
    const { backPress } = useNavigation();
    let query = useQuery();
    const { user } = useAuth();
    const { navigate } = useNavigation();

    const [currentHours, setCurrentHours] = useState(format(new Date(), 'HH'));
    const [currentMinutes, setCurrentMinutes] = useState(format(new Date(), 'mm'));
    const [currentDate, setCurrentDate] = useState(formatDateToDDMMYYYY(new Date()))
    const [selectingTime, setSelectingTime] = useState(false);
    const [scheduledTime, setScheduledTime] = useState(null);
    const { sendRequest, loading } = useRequest();

    const formData = usePageState();

    useEffect(() => {
        if (formData) {
            populateForm(formData)
        }
    }, [formData]);

    useEffect(() => {
        const time = `${currentHours}:${currentMinutes.toString().padStart(2, '0')}`;
        setScheduledTime(`${currentDate} ${time}`);
        setSelectingTime(false);
    }, [currentDate, currentMinutes, currentHours])

    const populateForm = (formData) => {
        if(formData.release && formData.validity ){
            const dateValue = parse(formData.release, 'dd/MM/yyyy', null)
            setCurrentDate(format(dateValue, 'dd/MM/yyyy'))
        }
    }
    
    const changeHours = result => {
        setCurrentHours(result.value);
    };
    const changeMinutes = result => {
        setCurrentMinutes(result.value);
    };
    const closeTimeSelection = () => {
        const time = `${currentHours}:${currentMinutes.toString().padStart(2, '0')}`;
        setScheduledTime(`${currentDate} ${time}`);
        setSelectingTime(false);
    };

    const onSubmit = async () => {

        let data = getDataForSubmit(formData)

        if (scheduledTime) {
            data['release'] = parseToMySQLDateTime(scheduledTime)
        }

        if (formData.validUntil) {
            data["validUntil"] = parseToMySQLDateTime(formData.validUntil)
        }

        const path = formData.id ? `/module/post/editPost` : `/module/post/createPost`

        await sendRequest({
            method: 'POST',
            url: path,
            data
        }).then((response) => {
            if (response.status === 'success') {
                if (formData.id) navigate(`/posts/updated/result`)
                else navigate(`/posts/${scheduledTime ? 'scheduled' : 'published'}/result`)
            }

        }).catch((error) => {
            console.log(error);
        })
    }

    return (
        <BringzzPageContainer
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),

                title: <BringzzText tag='h2'>{t('previewPost.title')}</BringzzText>
            }}
            footer={
                <div className='pb-28 px-6 flex flex-row space-x-2'>
                    <BringzzButton
                        onClick={onSubmit}
                        size='md'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        disabled={loading}
                    >
                        {formData.id ? t('previewPost.buttons.update') : t('previewPost.buttons.share')} {scheduledTime ? `| ${scheduledTime}` : ''}
                    </BringzzButton>
                    <div className='flex space-x-1'>
                        <BringzzButton disabled={loading} className='!p-0' onClick={() => setSelectingTime(true)}>
                            <BringzzIcon
                                folder='LineIcons'
                                className='bg-magic-lilac text-midnight-blue p-2 rounded-full cursor-pointer'
                                size='20'
                                icon='IconClockAlt1'
                            />
                        </BringzzButton>
                    </div>
                </div>
            }
        >
            <div className='p-4 space-y-4'>
                <PostingCardElement post={formData} user={user} preview={true}/>
            </div>
            <BringzzBottomDrawer
                isOpen={selectingTime}
                close={closeTimeSelection}
                title={t('previewPost.schedule.title')}
            >
                <div className='p-4'>
                    <BringzzDate
                        placeholder={t('previewPost.schedule.pickDate')}
                        format="dd/MM/yyyy"
                        onChange={(newDate) => setCurrentDate(newDate)}
                        mode={Mode.DAY}
                        minDate={new Date()}
                    ></BringzzDate>
                </div>
                <div className='flex items-center relative gap-x-4 justify-center'>
                    <div className='h-12 absolute top-1/2 right-0 w-full border-y -translate-y-1/2'></div>
                    <div>
                        <BringzzRotatingSelect
                            options={hoursOptions}
                            onSelect={changeHours}
                        />
                    </div>
                    <div>
                        <BringzzRotatingSelect
                            options={minutesOptions}
                            onSelect={changeMinutes}
                        />
                    </div>
                </div>
                <div className='flex justify-center items-center py-6'>
                    <BringzzButton
                        size='lg'

                        className='bg-magic-lilac '
                        onClick={closeTimeSelection}
                    >
                        {t('previewPost.buttons.apply')}
                    </BringzzButton>
                </div>
            </BringzzBottomDrawer>
        </BringzzPageContainer>

    );
};

export default PreviewPost;
